export default function BlumenauBanner() {
  return (
    <section className="bg-primary-50 border-y border-primary-200/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-3.5">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-sm">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-map-pin-line"></i>
            Blumenau/SC
          </span>
          <span className="text-foreground-700">
            Atendimento presencial em Blumenau/SC e também externo em sua
            localidade. Para atendimento externo, consulte a taxa de
            deslocamento.
          </span>
          <a
            href="tel:+5547991891311"
            className="inline-flex items-center gap-1 font-medium text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Agende e consulte: (47) 99189-1311
          </a>
        </div>
      </div>
    </section>
  );
}